import React from 'react';
import styled from '@emotion/styled';

import StatusBadge from '../../../common/StatusBadge';

const Wrapper = styled('div')`
  margin-top: -3px;
  margin-right: auto;
`;

const getBadgeText = ({ requirements, packings, pallets }) => {
  let badgeText = null;

  if (
    requirements?.packing_sticker_type === 'PDF' &&
    packings.filter((p) => !p?.files?.length).length
  ) {
    badgeText = 'Ожидает указания стикеров мест';
  }

  if (
    requirements?.packing_sticker_type === 'TEXT' &&
    packings.filter((p) => !p?.fbmStickerBarcode).length
  ) {
    badgeText = 'Ожидает указания штрихкодов мест';
  }
  if (
    requirements?.pallet_sticker_type === 'PDF' &&
    pallets?.filter((p) => !p?.files?.length).length
  ) {
    badgeText = 'Ожидает указания стикеров паллет';
  }

  return badgeText;
};

const PackingMarketplaceBadge = (props) => {
  const { requirements } = props;

  if (
    requirements?.packing_sticker_type !== 'PDF' &&
    requirements?.packing_sticker_type !== 'TEXT' &&
    requirements?.pallet_sticker_type !== 'PDF'
  )
    return null;

  const badgeText = getBadgeText(props);

  if (!badgeText) return null;

  return (
    <Wrapper>
      <StatusBadge
        status="needed"
        stylesData={{
          needed: {
            background: '#f1556c',
            color: '#fff',
          },
        }}
        translateData={{
          needed: badgeText,
        }}
      />
    </Wrapper>
  );
};

export default PackingMarketplaceBadge;
